import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

import { API } from '@/config/api';

// Shoot scheduling. Some rows came from a one-time Notion import (Calendario
// Shooting); everything new is created directly here -- this is NOT a Notion mirror,
// create/update/delete all write straight to dondoit's own notion_shoots table.
export const useOperationsShoots = (projectNotionPageId) => {
  const [shoots, setShoots] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchShoots = useCallback(async () => {
    try {
      setLoading(true);
      const params = projectNotionPageId ? { project_notion_page_id: projectNotionPageId } : {};
      const response = await axios.get(`${API}/operations/shoots`, { params });
      setShoots(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error('Error fetching shoots:', err);
    } finally {
      setLoading(false);
    }
  }, [projectNotionPageId]);

  useEffect(() => {
    fetchShoots();
  }, [fetchShoots]);

  const createShoot = async (shoot) => {
    try {
      await axios.post(`${API}/operations/shoots`, shoot);
      await fetchShoots();
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || err.message };
    }
  };

  const updateShoot = async (id, patch) => {
    try {
      await axios.patch(`${API}/operations/shoots/${id}`, patch);
      await fetchShoots();
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || err.message };
    }
  };

  const deleteShoot = async (id) => {
    try {
      await axios.delete(`${API}/operations/shoots/${id}`);
      await fetchShoots();
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || err.message };
    }
  };

  return { shoots, loading, refetch: fetchShoots, createShoot, updateShoot, deleteShoot };
};
